/**
 * Namespaces that are safe to name in a log line. Everything else is reported
 * as "unscoped" — `getStorage` takes arbitrary keys, so a bare identifier (or a
 * dynamic key such as `autosave_${key}`) must never reach Datadog verbatim.
 */
const SAFE_KEY_NAMESPACES = new Set([
  "autosave",
  "cache",
  // DHT-5279. Neither carries a user identifier: one holds a telemetry level,
  // the other a boolean. Listed so a corrupt-value diagnostic can name them
  // rather than reporting "unscoped".
  "datadogTelemetryKillSwitch",
  "datadogTelemetryLevel",
  "devCurrentUser",
  // DHT-5172: a boolean, the last-known launch-gate retry kill switch.
  "launchGateAutoRetry",
  "deviceIdentifier",
  "token",
  "trialAccessState",
  "trialCurrentUser",
  "users",
]);

/**
 * Storage keys are namespaced and several carry an identifier in their suffix
 * (`token:<org>:<sub>`, `cache:<org>:<user>`). Corrupt-storage diagnostics ship
 * to Datadog, so log only a known-safe leading namespace — enough to tell which
 * persisted value went bad, without putting a user identifier in the logs.
 */
export const storageKeyLabel = (key: string): string => {
  const namespace = key.split(/[:_]/)[0];

  return SAFE_KEY_NAMESPACES.has(namespace) ? namespace : "unscoped";
};
